export const selectedLanguage = "no";
export const i18nextLngKey = "i18nextLng";

export enum LANGUAGE {
  ENGLAND = "en",
  NORWAY = "no",
}
